import React from 'react';
import { connect } from 'react-redux';

const OrderRowItemMore = props => {
  const { propKey, order: { items }  } = props;
  const row = items[propKey];
  return (
    <div style={{display: 'flex', height: '64px', alignItems: 'center', padding: '8px'}}>
      <div style={{width: '150px'}}></div>
      <div style={{display: 'flex'}}>
        <div style={{width: '490px', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
          <div style={{color: '#3f51b5'}}>{row.descr}</div>
          <div style={{display: 'flex'}}>
            <div style={{display: 'flex', flexDirection: 'column', flex: '0 0 100px'}}>
              <div style={{fontSize: '12px', color: '#555'}}>Код</div>
              <div style={{fontSize: '14px', fontWeight: 'bold'}}>{row.code}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', flex: '0 0 200px'}}>
              <div style={{fontSize: '12px', color: '#555'}}>Наименование</div>
              <div style={{fontSize: '14px', fontWeight: 'normal'}}>{row.description}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', flex: '0 0 100px'}}>
              <div style={{fontSize: '12px', color: '#555'}}>Цена</div>
              <div style={{fontSize: '14px', fontWeight: 'bold'}}>{row.price}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'column', flex: '0 0 100px'}}>
              <div style={{fontSize: '12px', color: '#555'}}>Сумма</div>
              <div style={{fontSize: '14px', fontWeight: 'bold'}}>{row.amount}</div>
            </div>
          </div>
        </div>
        <div style={{width: '50px', fontWeight: 'bold'}}>
          <div>{row.qty}</div>
          <div>шт</div>
        </div>
      </div>
    </div>
  );
}

export default connect()(OrderRowItemMore);



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-confirmed/item-more.js